module.exports = __webpack_public_path__ + "img/work1.6374e58b.png";